const CookieService = {
  getCookie(name) {
    return getCookie(name);
  },
  setCookie(name, value, days = 30) {
    return setCookie(name, value, days);
  },
  removeCookie(name) {
    return deleteCookie(name);
  },
};

export default CookieService;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
}

function setCookie(name, value, minutes) {
  var d = new Date();
  d.setTime(d.getTime() + minutes * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
